require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-bic-impact-stories.json") })
        }
      }, "path---en-us-bic-impact-stories");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-bic-impact-stories!./.cache/json/en-us-bic-impact-stories.json
// module id = 467
// module chunks = 231608221292675